import cx from "classnames";

import Box from "../Box";
import Typography from "../Typography";
import styles from "./styles.module.css";

type ProgressBarProps = {
  current: number;
  max: number;
  fullWidth?: boolean;
  hideLabel?: boolean;
  ariaLabel: string;
  color?: string;
  isPercentage?: boolean;
};

const ProgressBar = ({
  current,
  max,
  fullWidth,
  ariaLabel,
  hideLabel,
  color,
  isPercentage,
}: ProgressBarProps) => {
  const clampedCurrent = Math.min(max, Math.max(0, current));

  const percentage = max > 0 ? (clampedCurrent * 100) / max : 0;

  const value = isPercentage ? `${percentage.toFixed(0)}%` : `${clampedCurrent}/${max}`;

  return (
    <Box
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuemin={0}
      aria-valuenow={clampedCurrent}
      aria-valuemax={max}
      gap="medium"
      align="center"
      grow={fullWidth ? "1" : "0"}
    >
      <div className={cx(styles.progressBar, fullWidth && styles.fullWidth)}>
        <div
          className={styles.progressBarValue}
          style={{ width: `${percentage}%`, backgroundColor: color }}
        />
      </div>
      {!hideLabel && (
        <Typography tag="span" variant="p-t7">
          {value}
        </Typography>
      )}
    </Box>
  );
};

ProgressBar.displayName = "DS.ProgressBar";

export default ProgressBar;
